<app-block-wrapper [_editable]="_editable()" [style]="style()">
  @switch (headingTag()) {
    @case ('h1') {
      <h1
        [attr.id]="finalAnchor()"
        class="{{ effectiveSizeClass() }} {{ effectiveStyleClass() }} {{ effectiveAlignment() }} a-m-{{
          mobileAlignment()
        }} a-t-{{ tabletAlignment() }} a-d-{{ desktopAlignment() }}"
        [class.has-size-override]="hasSizeOverride()"
        [style]="sizeOverrideStyles()"
        [innerHTML]="sanitizedTitle() ? (sanitizedTitle() | safeHtml) : 'EMPTY TITLE COMPONENT'"
      ></h1>
    }
    @case ('h3') {
      <h3
        [attr.id]="finalAnchor()"
        class="{{ effectiveSizeClass() }} {{ effectiveStyleClass() }} {{ effectiveAlignment() }} a-m-{{
          mobileAlignment()
        }} a-t-{{ tabletAlignment() }} a-d-{{ desktopAlignment() }}"
        [class.has-size-override]="hasSizeOverride()"
        [style]="sizeOverrideStyles()"
        [innerHTML]="sanitizedTitle() ? (sanitizedTitle() | safeHtml) : 'EMPTY TITLE COMPONENT'"
      ></h3>
    }
    @case ('h4') {
      <h4
        [attr.id]="finalAnchor()"
        class="{{ effectiveSizeClass() }} {{ effectiveStyleClass() }} {{ effectiveAlignment() }} a-m-{{
          mobileAlignment()
        }} a-t-{{ tabletAlignment() }} a-d-{{ desktopAlignment() }}"
        [class.has-size-override]="hasSizeOverride()"
        [style]="sizeOverrideStyles()"
        [innerHTML]="sanitizedTitle() ? (sanitizedTitle() | safeHtml) : 'EMPTY TITLE COMPONENT'"
      ></h4>
    }
    @default {
      <h2
        [attr.id]="finalAnchor()"
        class="{{ effectiveSizeClass() }} {{ effectiveStyleClass() }} {{ effectiveAlignment() }} a-m-{{
          mobileAlignment()
        }} a-t-{{ tabletAlignment() }} a-d-{{ desktopAlignment() }}"
        [class.has-size-override]="hasSizeOverride()"
        [style]="sizeOverrideStyles()"
        [innerHTML]="sanitizedTitle() ? (sanitizedTitle() | safeHtml) : 'EMPTY TITLE COMPONENT'"
      ></h2>
    }
  }
</app-block-wrapper>
